<template>
  <vue-modal-custom v-model="modal.visible"
    :header="false"
    :backdrop="false"
    :keyboard="false"
    :footer="false"
    :modalBodyClass="$prefixClass.modal + `-free-used-promotion`">
    <img src="../assets/icons/extended-success.svg" />
    <h3 class="m-b-8">{{$t('promotion.free_warning.title')}}</h3>
    <span v-html="$t('promotion.free_warning.description')"></span>
    <ul>
      <li>{{$t('promotion.free_warning.option_one')}}</li>
      <li>{{$t('promotion.free_warning.option_two')}}</li>
    </ul>
    <div class="free-used-promotion__actions">
      <a-button type="secondary" class="m-r-8" @click="onClose">{{$t("promotion.buttons.keep_free")}}</a-button>
      <a-button type="primary" @click="upgrade" :disabled="modal.charging">{{$t("promotion.buttons.upgrade_plan")}}</a-button>
    </div>
  </vue-modal-custom>
</template>

<script>
export default {
  name: 'FreeUsedPromotion',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
    modal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    onClose() {
      this.modal.visible = false
    },
    upgrade() {
      this.$emit('upgrade')
    }
  }
}
</script>
<style lang="scss">
.#{$modal}-free-used-promotion {
  width: 563px !important;

  .#{$modal} {
    &-close {
      color: $text-color-secondary !important;
    }
    &-body {
      padding: 28px 58px 32px;
      text-align: center;
      ul {
        margin-left: 18px;
        list-style-type: disc;
        margin-top: 8px;
        text-align: left;
        margin-bottom: 28px;
      }
      .free-used-promotion__actions {
        .a-btn {
          height: 40px;
        }
      }
    }
  }
}

</style>